import React from "react";
import { FaSave, FaUserPlus, FaPaperPlane } from "react-icons/fa";

const PoolModalNavBar = ({
  activeSection, isPoolOwner, poolRecord, handleSave, mode, canEdit,
  showSaveButton, showInviteButtons, onAddEmail, onSendInvites, isSubmitting
}) => {
  const handleSendInvites = async (e) => {
    e.preventDefault();
    if (onSendInvites) await onSendInvites();
  };

  return (
    <div className="border-t border-gray-200 bg-gray-50 px-6 py-4 flex items-center justify-end gap-3 rounded-b-2xl">
      {showSaveButton && (
        <button
          type="button"
          onClick={handleSave}
          disabled={!canEdit || isSubmitting}
          className="flex items-center gap-2 bg-primary hover:bg-primary-hover text-white font-semibold py-2.5 px-5 rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-sm"
        >
          <FaSave className="w-4 h-4" />
          Save Changes
        </button>
      )}
      {showInviteButtons && (
        <>
          <button
            type="button"
            onClick={onAddEmail}
            disabled={isSubmitting}
            className="flex items-center gap-2 bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 font-medium py-2.5 px-4 rounded-xl transition-all text-sm disabled:opacity-50"
          >
            <FaUserPlus className="w-3.5 h-3.5" />
            Add
          </button>
          <button
            type="button"
            onClick={handleSendInvites}
            disabled={isSubmitting}
            className="flex items-center gap-2 bg-primary hover:bg-primary-hover text-white font-semibold py-2.5 px-5 rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-sm"
          >
            <FaPaperPlane className="w-3.5 h-3.5" />
            {isSubmitting ? "Sending..." : "Send Invites"}
          </button>
        </>
      )}
    </div>
  );
};

export default PoolModalNavBar;
